export const messages = {
  en: {
    supplierTypeManage: {
      search: {
        title: 'Search Conditions',
        typeCd: 'Please enter type code',
        typeName: 'Please enter type name'
      },
      list: {
        title: 'Supplier Type List'
      },
      table: {
        typeCd: 'Type Code',
        typeName: 'Type Name',
        createTime: 'Create Time',
        remark: 'Remark'
      },
      form: {
        typeCd: 'Type Code',
        typeName: 'Type Name',
        remark: 'Remark'
      },
      placeholder: {
        typeCd: 'Please enter type code',
        typeName: 'Please enter type name',
        remark: 'Please enter remark'
      },
      validate: {
        typeCdRequired: 'Type code is required',
        typeCdMaxLength: 'Type code cannot exceed 32 characters',
        typeNameRequired: 'Type name is required',
        typeNameMaxLength: 'Type name cannot exceed 255 characters',
        remarkRequired: 'Remark is required',
        remarkMaxLength: 'Remark cannot exceed 512 characters',
        stIdRequired: 'ID is required'
      },
      message: {
        addSuccess: 'Add success',
        editSuccess: 'Edit success',
        deleteSuccess: 'Delete success',
        fetchError: 'Failed to fetch data'
      },
      add: {
        title: 'Add Supplier Type'
      },
      edit: {
        title: 'Edit Supplier Type'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this supplier type?'
      }
    }
  },
  zh: {
    supplierTypeManage: {
      search: {
        title: '查询条件',
        typeCd: '请输入类型编码',
        typeName: '请输入类型名称'
      },
      list: {
        title: '供应商类型'
      },
      table: {
        typeCd: '类型编码',
        typeName: '类型名称',
        createTime: '创建时间',
        remark: '备注'
      },
      form: {
        typeCd: '类型编码',
        typeName: '类型名称',
        remark: '备注'
      },
      placeholder: {
        typeCd: '请输入类型编码',
        typeName: '请输入类型名称',
        remark: '请输入备注'
      },
      validate: {
        typeCdRequired: '类型编码不能为空',
        typeCdMaxLength: '类型编码不能超过32个字符',
        typeNameRequired: '类型名称不能为空',
        typeNameMaxLength: '类型名称不能超过255个字符',
        remarkRequired: '备注不能为空',
        remarkMaxLength: '备注不能超过512个字符',
        stIdRequired: '编号不能为空'
      },
      message: {
        addSuccess: '添加成功',
        editSuccess: '修改成功',
        deleteSuccess: '删除成功',
        fetchError: '获取数据失败'
      },
      add: {
        title: '添加供应商类型'
      },
      edit: {
        title: '修改供应商类型'
      },
delete: {
        title: '刪除確認',
        confirm: '確定刪除該供應商類型嗎？'
      }
    }
  },
  'zh-TW': {
    supplierTypeManage: {
      search: {
        title: '查詢條件',
        typeCd: '請輸入類型編碼',
        typeName: '請輸入類型名稱'
      },
      list: {
        title: '供應商類型'
      },
      table: {
        typeCd: '類型編碼',
        typeName: '類型名稱',
        createTime: '創建時間',
        remark: '備註'
      },
      form: {
        typeCd: '類型編碼',
        typeName: '類型名稱',
        remark: '備註'
      },
      placeholder: {
        typeCd: '請輸入類型編碼',
        typeName: '請輸入類型名稱',
        remark: '請輸入備註'
      },
      validate: {
        typeCdRequired: '類型編碼不能為空',
        typeCdMaxLength: '類型編碼不能超過32個字符',
        typeNameRequired: '類型名稱不能為空',
        typeNameMaxLength: '類型名稱不能超過255個字符',
        remarkRequired: '備註不能為空',
        remarkMaxLength: '備註不能超過512個字符',
        stIdRequired: '編號不能為空'
      },
      message: {
        addSuccess: '添加成功',
        editSuccess: '修改成功',
        deleteSuccess: '刪除成功',
        fetchError: '獲取數據失敗'
      },
      add: {
        title: '添加供應商類型'
      },
      edit: {
        title: '修改供應商類型'
      },
      delete: {
        title: '刪除確認',
        confirm: '確定刪除該供應商類型嗎？'
      }
    }
  }
}